module.exports = __webpack_public_path__ + "static/media/multipostingHelper1.1e67536c.png";